<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="6" sm="6" xs="6" md="6" lg="6" xl="6">
        <v-btn :small="$vuetify.breakpoint.name == 'xs' ? true : false" :disabled="backDisable" color="info"
          @click="progressCarrousel('back', true)">Clase Anterior</v-btn>
      </v-col>
      <!-- <v-col cols="6" sm="6" xs="6" md="6" lg="6" xl="6">
          <div class="text-center text-h5">
            {{ item.nombre }}
          </div>
        </v-col> -->
      <v-col cols="6" sm="6" xs="6" md="6" lg="6" xl="6">
        <v-btn :disabled="nextDisable" :small="$vuetify.breakpoint.name == 'xs' ? true : false" class="float-right"
          color="info" @click="progressCarrousel('next', true)">Siguiente Clase</v-btn>
      </v-col>

      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h2>{{ item.nombre }}</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-sheet class="black--text " v-html="item.programa"></v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" style="padding-top: 0;margin-top: 0;">
        <youtube v-if="videoReady && currentVideoId"  :video-id="currentVideoId" width="100%" ref="youtube" @ready="changeYT('ready')" @playing="changeYT('playing')"
          @paused="changeYT('paused')" @buffering="changeYT('buffering')" @ended="changeYT('ended')"
          @cued="changeYT('cued')" @error="onError"></youtube>
          <div v-else class="loading-placeholder">
      Cargando video...
    </div>
      </v-col>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-carousel v-model="model" height="100%" progress :continuous="false" progress-color="green" hide-delimiters
          :show-arrows="false" touchless :eager="true" :value="model" @change="onCarouselChange">
          <v-carousel-item v-for="(itemClase, i) in item.materia_codigo_clase" :key="`clase-${i}`" :value="i">
            <v-card height="100%" color="#F5F5F5" elevation="12" v-if="model === i">
              <!-- Botón de descarga de actividades -->
              <v-btn v-if="itemClase.actividades_clase" color="primary" class="mt-4" block elevation="2"
                @click="downloadActividades(itemClase.actividades_clase)">
                <v-icon left>mdi-download</v-icon>
                ACTIVIDADES DE LA CLASE
              </v-btn>

              <v-list class="transparent">
                <v-subheader class="black--text">CONTENIDO DE LA CLASE</v-subheader>

                <v-list-item>
                  <v-list-item-content style="display: block;">
                    <!-- <v-col cols="12"> -->
                    <v-sheet class="black--text "></v-sheet>
                    <v-sheet outlined color="transparent" class="black--text mb-3" v-html="itemClase.clase">
                    </v-sheet>
                    <!-- </v-col> -->
                    <!-- <v-col cols="12"> -->
                    <v-list-item-subtitle class="black--text">Tiempo: {{ itemClase.minutos }} min</v-list-item-subtitle>
                    <!-- </v-col> -->
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list class="transparent" shaped>
                <v-subheader class="black--text">VIDEO DE LA CLASE</v-subheader>
                <v-divider color="grey"></v-divider>
                <v-list-item-group color="primary" v-model="reproductorActualBackgroundList">
                  <template>
                    <div v-for="(link, index) in itemClase.materia_codigo_link" v-frag :key="index">
                      <v-list-item @click="nextVideo(link, index, i)">
                        <v-list-item-content>
                          <v-list-item-title class="black--text">Video {{ index + 1 }} de
                            {{ itemClase.materia_codigo_link.length }}
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-icon v-if="reproductorActual == index">
                          <v-progress-circular :value="link.porcentaje" color="blue">
                            <v-icon color="black">mdi-play</v-icon>
                          </v-progress-circular>
                        </v-list-item-icon>

                        <v-list-item-icon v-else>
                          <v-progress-circular :value="100" color="green" v-if="link.finalizado">
                            <v-icon color="black">mdi-check</v-icon>
                          </v-progress-circular>

                          <v-progress-circular :value="link.porcentaje" color="red" v-else>
                            <v-icon color="black">mdi-stop</v-icon>
                          </v-progress-circular>
                        </v-list-item-icon>
                      </v-list-item>

                      <v-divider color="grey"></v-divider>
                    </div>
                  </template>
                </v-list-item-group>
              </v-list>

              <v-list class="transparent">
                <v-subheader class="black--text">BIBLIOGRAFÍA</v-subheader>
                <v-list-item>
                  <v-list-item-content style="display: block;">
                    <!-- <v-col cols="12"> -->
                    <v-sheet class="black--text "></v-sheet>
                    <v-sheet v-if="item.bibliografia != null" outlined color="transparent" class="black--text mb-3"
                      v-html="item.bibliografia">
                    </v-sheet>

                    <div v-else>
                      Sin contenido.
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>

    <div class="text-center">
      <v-dialog v-model="dialogPasoClase" width="500" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Esta saliendo de una clase en curso
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <h2>¿Estás queriendo saltar de clase? ¿Porqué?</h2>
              </v-col>
            </v-row>
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
              <v-textarea v-model="textareaCambioClaseForzado"></v-textarea>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="" text @click="dialogPasoClase = false">
              Cancelar
            </v-btn>

            <v-btn color="primary" text @click="guardarCambioClaseForzado()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="dialogValoracionVideo" persistent width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            ¿ Cómo te fue te fue con este contenido ?
          </v-card-title>

          <v-card-text class="mt-2">
            <v-row align="center" justify="center">
              <div v-frag v-for="(item, index) in labelsRating" :key="index">
                <vue-reaction-emoji @input="feedback(index)" :reaction="item.reaction" :is-active="item.isActive"
                  :is-disabled="item.isDisabled" width="50" height="50" />
              </div>
            </v-row>

            <v-col cols="12" v-if="saltoVideo">
              <v-checkbox v-model="necesitaAyudaMaterial" label="¿ Necesita ayuda con el material ?"></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="saltoVideo && necesitaAyudaMaterial">
              <v-textarea label="Describe tu problema" v-model="comentarioNecesitoAyuda"></v-textarea>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="" text @click="dialogValoracionVideo = false">
              Cancelar
            </v-btn>

            <v-btn color="primary" text @click="aceptarFeedback()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="dialofaltaClase" width="500" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Aun hay clases pendientes
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <h2>
                  No has terminado de ver todos los videos, por favor , concluye
                  todos los videos de la clase para poder pasar a la siguiente
                </h2>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialofaltaClase = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import { VueReactionEmoji } from "vue-feedback-reaction";
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    VueReactionEmoji,
    CardIeaAppMain
  },

  data: () => ({
    videoReady: false,
    currentVideoId: null,
    tipoBoton: "",
    alumno_id: "",
    alumno: 0,
    model: 0,
    nextDisable: false,
    backDisable: true,
    dialogPasoClase: false,
    dialogValoracionVideo: false,
    dialofaltaClase: false,
    rating: 0,
    reproductorActualBackgroundList: 0,
    reproductorActual: 0,
    claseActual: 0,
    reproductorSiguiente: 0,
    claseSiguiente: 0,
    procentajeActual: 10,
    interval: "",
    textareaCambioClaseForzado: "",
    labelsRating: [
      {
        reaction: "hate",
        isActive: false,
        isDisabled: false,
        valoracion: 1
      },
      {
        reaction: "natural",
        isActive: false,
        isDisabled: false,
        valoracion: 2
      },
      {
        reaction: "excellent",
        isActive: false,
        isDisabled: false,
        valoracion: 3
      }
    ],

    item: {},

    saltoVideo: true,
    necesitaAyudaMaterial: false,
    comentarioNecesitoAyuda: "",
    tipoVideo: null,
    todosTerminados: false,
    clasesTerminadas: false,
    docente: false
  }),

  methods: {
    initializeVideo() {
      const linkData = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual];

      const videoId = linkData.link;

      console.log('Inicializando video con ID:', videoId);

      // Validar el ID antes de asignarlo
      // const validation = true;

      // if (!validation.valid) {
      //   console.error('ID inválido:', validation.error);
      //   this.onError({ data: 2, message: validation.error });
      //   return;
      // }

      // Asignar el ID validado
      this.currentVideoId = videoId;
      this.videoReady = true;

      // Esperar a que el componente se monte antes de buscar el player
      // this.$nextTick(() => {
      //   this.setupPlayer(linkData.videoActualSegundo || 0);
      // });
    },
    setupPlayer(startSeconds) {
      // Esperar a que el player esté listo
      const checkPlayer = () => {
        if (this.$refs.youtube && this.$refs.youtube.player) {
          this.player = this.$refs.youtube.player;

          // Si necesitas cargar desde un tiempo específico
          if (startSeconds > 0) {
            this.player.seekTo(startSeconds);
          }

          console.log('Player configurado correctamente');
        } else {
          // Reintentar después de un tiempo
          setTimeout(checkPlayer, 100);
        }
      };

      checkPlayer();
    },
    onError(error) {
      console.error('Error en vue-youtube:', error);
      this.handleYouTubeError(error);
    },
    handleYouTubeError(error) {
      // Códigos de error de YouTube
      const errorMessages = {
        2: 'ID de video inválido',
        5: 'Error de reproducción',
        100: 'Video no encontrado o privado',
        101: 'Reproducción embebida no permitida',
        150: 'Reproducción embebida no permitida'
      };

      const message = errorMessages[error] || 'Error desconocido';
      console.error(`Error YouTube: ${message}`);

      // Mostrar mensaje al usuario o cargar video alternativo
      // this.$emit('video-error', { code: error, message });
    },
    inicializarTodo() {
      if (this.$route.params.alumno) {
        this.alumno_id = this.$route.params.alumno;
      } else {
        this.alumno_id = this.user.IDStB;
      }
      if (
        this.$route.params.catedra &&
        this.$route.params.planestudio &&
        this.alumno_id
      ) {
        this.$API
          .post({
            url: "materiaCodigo/show",
            data: {
              catedra: this.$route.params.catedra,
              planestudio: this.$route.params.planestudio,
              alumno: this.alumno_id
            }
          })
          .then(res => {
            console.log(res);
            this.item = res;
            (this.reproductorActual = res.video),
              (this.claseActual = res.clase);
            this.model = res.clase;
            if (res.clase > 0) {
              this.backDisable = false;
            }

            //console.log(this.item.materia_codigo_clase.length -1,res.clase)

            let totalV = this.item.materia_codigo_clase.length - 1;

            if (res.clase > totalV) {
              this.claseActual = totalV;
            }

            let cantidadClases = this.item.materia_codigo_clase[
              this.claseActual
            ].materia_codigo_link;

            cantidadClases = cantidadClases.length;

            if (res.clase == cantidadClases) {
              this.nextDisable = true;
            }

            console.log("esta es la clase actual", this.claseActual)
            console.log("esta es el reproductor actual", this.claseActual)
            console.log('este es link', this.item.materia_codigo_clase[this.claseActual]
              .materia_codigo_link[this.reproductorActual].link)

            //console.log(this.reproductorActual)
            //   this.reproductorActualBackgroundList = this.reproductorActual
            this.player.loadVideoById({
              videoId: this.item.materia_codigo_clase[this.claseActual]
                .materia_codigo_link[this.reproductorActual].link,
              startSeconds:
                this.item.materia_codigo_clase[this.claseActual]
                  .materia_codigo_link[this.reproductorActual]
                  .videoActualSegundo || 0
            });

            this.intervalProcentaje();
          });
      }
    },

    progressCarrousel(type, btn = "") {
      this.tipoBoton = type;
      this.verificarTodosVideoTerminado();
      let temp = this.item.materia_codigo_clase;
      if (type == "next" && btn) {
        let videosActual = temp[this.model].materia_codigo_link;
        let cantidadFinalizados = 0;
        let cantidadVideosActual = videosActual.length;

        for (let index in videosActual) {
          if (videosActual[index].finalizado) {
            cantidadFinalizados++;
          }
        }
        // console.log(videosActual,cantidadVideosActual,cantidadFinalizados)
        if (cantidadFinalizados != cantidadVideosActual) {
          this.todosTerminados = false;
          this.player.pauseVideo();
          if (this.docente != true) {
            this.dialogPasoClase = true;
            return;
          }
        }

        // console.log(cantidadFinalizados, videosActual.length);
      }
      /*

      if (type == "next" && !btn) {
        if (!this.todosTerminados) {
          this.dialofaltaClase = true;
          // alert("falta videos")
          return;
        }
      }
      */
      // return
      let tamano = temp.length - 1;
      if (type == "next") {
        if (this.model != tamano) {
          this.model++;
        }
      } else {
        if (this.model != 0) {
          this.model--;
        }
      }

      if (this.model == 0) {
        this.backDisable = true;
        this.nextDisable = false;
      } else {
        if (this.model == tamano) {
          this.backDisable = false;
          this.nextDisable = true;
        } else {
          this.backDisable = false;
          this.nextDisable = false;
        }
      }
      let tempItem = this.item.materia_codigo_clase[this.model]
        .materia_codigo_link;

      // let video = null;
      // let itemVideo = null;
      // console.log("tempItem", tempItem);
      for (let index in tempItem) {
        if (!tempItem[index].finalizado) {
          // console.log("un finalizado");
          this.nextVideo(tempItem[index], index, this.model);
          return;
        } else {
          this.nextVideo(tempItem[index], index, this.model);
          return;
        }
      }
      // this.nextVideo(
      //   this.item.materia_codigo_clase[this.model].materia_codigo_link[0],
      //   0,
      //   this.model
      // );
    },
    async nextVideo(item, video, clase) {
      let valorado = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual].valorado;

      let finalizado = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual].finalizado;

      if (this.reproductorActual != video || this.claseActual != clase) {
        this.player.pauseVideo();
        // clearInterval(this.interval);
        this.reproductorSiguiente = video;
        this.claseSiguiente = clase;
        if (!valorado && this.docente == false) {
          this.rating = 0;
          this.necesitaAyudaMaterial = false;
          this.comentarioNecesitoAyuda = "";
          this.dialogValoracionVideo = true;
        } else {
          if (!finalizado) {
            let infoVideo = this.item.materia_codigo_clase[this.claseActual]
              .materia_codigo_link[this.reproductorActual];

            let dataSend = {
              alumno_id: parseInt(this.alumno_id),
              materiaCodigoClase_id: infoVideo.materiaCodigoClase_id,
              materiaCodigoLink_id: infoVideo.id,

              posicionClase: this.claseActual,
              posicionVideo: this.reproductorActual,

              videoTranscurrido: infoVideo.videoActualSegundo || 0,
              videoDuracion: infoVideo.videoDuracion,
              videoPorcentaje: infoVideo.porcentaje,
              puntosValorado: 0,
              necesitaAyudaMaterial: this.necesitaAyudaMaterial,
              comentarioAyuda: this.comentarioNecesitoAyuda,
              tipo: this.tipoVideo,
              docente: this.docente
            };
            await this.$API
              .post({
                url: "materiaCodigoEstadistica/store/teminoVideoValorado",
                data: dataSend
              })
              .then(() => {
                this.item.materia_codigo_clase[
                  this.claseActual
                ].materia_codigo_link[this.reproductorActual].finalizado = true;

                let videosActual = this.item.materia_codigo_clase[
                  this.claseActual
                ].materia_codigo_link;

                // console.log("videosActual",videosActual)
                let cantidadFinalizados = 0;
                let cantidadVideosActual = videosActual.length;

                for (let index in videosActual) {
                  if (videosActual[index].finalizado) {
                    cantidadFinalizados++;
                  }
                }
                // console.log(videosActual,cantidadVideosActual,cantidadFinalizados)
                // console.log(cantidadFinalizados,cantidadVideosActual)
                if (
                  cantidadFinalizados == cantidadVideosActual &&
                  this.claseSiguiente >= this.claseActual
                ) {
                  this.todosTerminados = true;
                  // this.player.pauseVideo();
                  // this.dialogPasoClase = true;
                  // return;

                  // alert("todos finalizados , siguiente clase?")
                  //this.progressCarrousel(this.tipoBoton);
                  this.playVideo();
                  return;
                }

                this.playVideo();
              });
          } else {
            this.playVideo();
          }
        }
      }
    },
    async aceptarFeedback() {
      // base de datos aceptado feedback
      if (this.rating == 0) {
        alert("Debe colocar una valoracion");
        return;
      }
      let infoVideo = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual];

      let dataSend = {
        alumno_id: parseInt(this.alumno_id),
        materiaCodigoClase_id: infoVideo.materiaCodigoClase_id,
        materiaCodigoLink_id: infoVideo.id,

        posicionClase: this.claseActual,
        posicionVideo: this.reproductorActual,

        videoTranscurrido: infoVideo.videoActualSegundo || 0,
        videoDuracion: infoVideo.videoDuracion,
        videoPorcentaje: infoVideo.porcentaje,
        puntosValorado: this.rating,
        necesitaAyudaMaterial: this.necesitaAyudaMaterial,
        comentarioAyuda: this.comentarioNecesitoAyuda,
        tipo: this.tipoVideo
      };

      let url = "materiaCodigoEstadistica/store/teminoVideo";
      if (this.saltoVideo) {
        url = "materiaCodigoEstadistica/store/saltoVideo";
      }

      // termino video
      await this.$API
        .post({
          url: url,
          data: dataSend
        })
        .then(() => {
          // console.log("dataSend", res);
          this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
            this.reproductorActual
          ].valorado = true;
          if (!this.saltoVideo) {
            this.item.materia_codigo_clase[
              this.claseActual
            ].materia_codigo_link[this.reproductorActual].finalizado = true;
          }
          let cantidadDeclase = this.item.materia_codigo_clase.length - 1;
          this.dialogValoracionVideo = false;
          console.log(this.claseSiguiente, cantidadDeclase);
          if (this.claseSiguiente != cantidadDeclase) {
            this.playVideo();
          } else {
            this.playVideo();
          }

          // this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[this.reproductorActual].finalizado = true
        });
    },
    async playVideo() {
      // let videosActual = this.item.materia_codigo_clase.length - 1;

      // console.log("videosActual",videosActual,this.claseSiguiente)
      // if(videosActual == this.claseSiguiente){
      //   alert("final de todo")
      //   clearInterval(this.interval);
      //   this.interval = null
      //   return
      // }

      this.reproductorActual = this.reproductorSiguiente;
      // this.reproductorActualBackgroundList = this.reproductorActual
      this.claseActual = this.claseSiguiente;
      let item = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual];
      if (item.finalizado) {
        this.player.loadVideoById({ videoId: item.link, startSeconds: 0 });
      } else {
        this.player.loadVideoById({
          videoId: item.link,
          startSeconds: item.videoActualSegundo || 0
        });
      }
    },
    async changeYT(tipo) {
      this.tipoVideo = tipo;
      if (tipo == "playing") {
        if (this.interval == null) {
          this.intervalProcentaje();
        }
        // server post comenzo video
        this.todosTerminados = false;
        this.rating = 0;
        this.saltoVideo = true;
        this.labelsRating[0].isActive = false;
        this.labelsRating[1].isActive = false;
        this.labelsRating[2].isActive = false;
        // await this.intervalProcentaje();
      }

      if (tipo == "ended") {
        this.verificarTodosVideoTerminado();
        // clearInterval(this.interval);

        this.saltoVideo = false;

        let claseActualReproduciondo = this.item.materia_codigo_clase[
          this.claseActual
        ];
        let cantidadDeVideosXclase =
          claseActualReproduciondo.materia_codigo_link.length - 1;
        let cantidadDeclase = this.item.materia_codigo_clase.length - 1;

        // let actual = this.item.materia_codigo_clase[this.claseActual]
        //   .materia_codigo_link[this.reproductorActual];

        let siguienteVideo = null;
        let itemSiguiente = null;
        let claseSiguiente = null;

        // para poner le video como finalizado

        // this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
        //   this.reproductorActual
        // ].finalizado = true;

        // console.log(cantidadDeVideosXclase, claseActualReproduciondo, actual);

        if (this.reproductorActual == cantidadDeVideosXclase) {
          siguienteVideo = 0;
          if (this.claseActual == cantidadDeclase) {
            // empty
          } else {
            itemSiguiente = this.item.materia_codigo_clase[this.claseActual]
              .materia_codigo_link[this.reproductorActual];
            claseSiguiente = this.claseActual + 1;
            this.evaluarBotonesClases(claseSiguiente);
            // this.progressCarrousel("next");
            // return
          }
        } else {
          siguienteVideo = this.reproductorActual + 1;
          itemSiguiente = this.item.materia_codigo_clase[this.claseActual]
            .materia_codigo_link[siguienteVideo];
          claseSiguiente = this.claseActual;
          this.evaluarBotonesClases(claseSiguiente);
        }
        this.nextVideo(itemSiguiente, siguienteVideo, claseSiguiente);
      }

      if (tipo == "paused") {
        // clearInterval(this.interval);
      }

      if (tipo == "paused") {
        let infoVideo = this.item.materia_codigo_clase[this.claseActual]
          .materia_codigo_link[this.reproductorActual];
        let porcentaje =
          infoVideo.porcentaje == null ? 0 : infoVideo.porcentaje;
        let dataSend = {
          alumno_id: parseInt(this.alumno_id),
          materiaCodigoClase_id: infoVideo.materiaCodigoClase_id,
          materiaCodigoLink_id: infoVideo.id,

          posicionClase: this.claseActual,
          posicionVideo: this.reproductorActual,

          videoTranscurrido: infoVideo.videoActualSegundo || 0,
          videoDuracion: infoVideo.videoDuracion,
          videoPorcentaje: porcentaje,
          tipo: this.tipoVideo,
          docente: this.docente
        };
        // console.log("se manda un post al servidor pausado", dataSend);
        await this.$API
          .post({
            url: "materiaCodigoEstadistica/store/statusVideo",
            data: dataSend
          })
          .then(() => { });
      }

      if (tipo == "playing") {
        let infoVideo = this.item.materia_codigo_clase[this.claseActual]
          .materia_codigo_link[this.reproductorActual];
        let porcentaje =
          infoVideo.porcentaje == null ? 0 : infoVideo.porcentaje;
        let dataSend = {
          alumno_id: parseInt(this.alumno_id),
          materiaCodigoClase_id: infoVideo.materiaCodigoClase_id,
          materiaCodigoLink_id: infoVideo.id,

          posicionClase: this.claseActual,
          posicionVideo: this.reproductorActual,

          videoTranscurrido: infoVideo.videoActualSegundo || 0,
          videoDuracion: infoVideo.videoDuracion,
          videoPorcentaje: porcentaje,
          tipo: this.tipoVideo,
          docente: this.docente
        };
        // console.log("se manda un post al servidor play", dataSend);
        await this.$API
          .post({
            url: "materiaCodigoEstadistica/store/statusVideo",
            data: dataSend
          })
          .then(() => { });
      }

      // console.log(
      //   "cambio",
      //   tipo,
      //   this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
      //     this.reproductorActual
      //   ]
      // );
      // let a = await this.player.getPlayerState()
      // console.log("cambio 222", a);
    },
    intervalProcentaje() {
      this.interval = setInterval(async () => {
        // console.log("interval")
        if (this.claseActual == null) {
          this.claseActual = 0;
          return;
        }
        let tiempoTranscurrido = await this.player.getCurrentTime();
        let tiempoMaximo = await this.player.getDuration();

        let porcentaje = parseInt((tiempoTranscurrido / tiempoMaximo) * 100);

        // console.log("typo",porcentaje);
        porcentaje = isNaN(porcentaje) ? 0 : porcentaje;
        // console.log("typo 2",porcentaje);

        // let temp = this.item.materia_codigo_clase[this.claseActual]
        //   .materia_codigo_link[this.reproductorActual].porcentaje;

        try {
          this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
            this.reproductorActual
          ].porcentaje = porcentaje;
        } catch (error) {
          console.log(error);
          this.inicializarTodo();
          //alert("error al pasar el video! por favor recarga la pagina");
        }

        this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
          this.reproductorActual
        ].videoActualSegundo = tiempoTranscurrido;

        this.item.materia_codigo_clase[this.claseActual].materia_codigo_link[
          this.reproductorActual
        ].videoDuracion = tiempoMaximo;

        // console.log("porcentaje", porcentaje);
      }, 100);
    },
    feedback(index) {
      this.labelsRating[0].isActive = false;
      this.labelsRating[1].isActive = false;
      this.labelsRating[2].isActive = false;

      this.labelsRating[index].isActive = true;
      this.rating = this.labelsRating[index].valoracion;
    },
    async guardarCambioClaseForzado() {
      /*
      if (this.textareaCambioClaseForzado == "") {
        alert("falta texto");
        return;
      }
    */
      let infoVideo = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link[this.reproductorActual];

      let dataSend = {
        alumno_id: parseInt(this.alumno_id),
        materiaCodigoClase_id: infoVideo.materiaCodigoClase_id,
        materiaCodigoLink_id: infoVideo.id,

        necesitaAyudaMaterial: 1,
        comentarioAyuda: this.textareaCambioClaseForzado,
        docente: this.docente
      };

      await this.$API
        .post({
          url: "materiaCodigoEstadistica/store/storeSaltoClase",
          data: dataSend
        })
        .then(() => {
          this.dialogPasoClase = false;
          this.textareaCambioClaseForzado = "";
          let temp = this.item.materia_codigo_clase;

          let tamano = temp.length - 1;

          if (this.model != tamano) {
            this.model++;
          }

          let tempItem = this.item.materia_codigo_clase[this.model]
            .materia_codigo_link;

          for (let index in tempItem) {
            if (!tempItem[index].finalizado) {
              // console.log("un finalizado");
              this.nextVideo(tempItem[index], index, this.model);
              return;
            } else {
              this.nextVideo(tempItem[index], index, this.model);
              return;
            }
          }
        });
    },
    verificarTodosVideoTerminado() {
      let videosActual = this.item.materia_codigo_clase[this.claseActual]
        .materia_codigo_link;

      // console.log("videosActual",videosActual)
      let cantidadFinalizados = 0;
      let cantidadVideosActual = videosActual.length;

      for (let index in videosActual) {
        if (videosActual[index].finalizado) {
          cantidadFinalizados++;
        }
      }
      // console.log(videosActual,cantidadVideosActual,cantidadFinalizados)
      // console.log(cantidadFinalizados,cantidadVideosActual)
      if (cantidadFinalizados == cantidadVideosActual) {
        this.todosTerminados = true;
      } else {
        this.todosTerminados = false;
      }
    },
    evaluarBotonesClases(claseSiguiente) {
      if (!this.todosTerminados) {
        return;
      }
      this.model = claseSiguiente;
      let temp = this.item.materia_codigo_clase;
      let tamano = temp.length - 1;
      if (this.model == 0) {
        this.backDisable = true;
        this.nextDisable = false;
      } else {
        if (this.model == tamano) {
          this.backDisable = false;
          this.nextDisable = true;
        } else {
          this.backDisable = false;
          this.nextDisable = false;
        }
      }
    },
    async downloadActividades() {
      try {
        // Get SCORM content URL and viewer
        const response = await this.$API.get({
          url: `materiaCodigo/serve-scorm-content/${this.item.materia_codigo_clase[this.model].id}`
        });

        if (response.viewer_url) {
          // Open SCORM content in a new tab with the viewer
          window.open(response.viewer_url, '_blank');
        } else {
          console.error("No se pudo obtener la URL del visor SCORM");
        }
      } catch (error) {
        console.error("Error al abrir las actividades SCORM:", error);
      }
    },
    onCarouselChange(value) {
      this.model = value;
      this.progressCarrousel("next");
    }
  },

  mounted() {
    if (this.$route.params.alumno) {
      this.alumno_id = this.$route.params.alumno;
    } else {
      this.alumno_id = this.user.IDStB;
    }
    if (this.user.tipoUsuario == "profesor") {
      this.docente = true;
    } else {
      this.docente = false;
    }
    if (
      this.$route.params.catedra &&
      this.$route.params.planestudio &&
      this.alumno_id
    ) {

      console.log("test error")

      this.$API
        .post({
          url: "materiaCodigo/show",
          data: {
            catedra: this.$route.params.catedra,
            planestudio: this.$route.params.planestudio,
            alumno: this.alumno_id,
            docente: this.docente
          }
        })
        .then(res => {
          console.log(res);
          this.item = res;
          (this.reproductorActual = res.video), (this.claseActual = res.clase);
          this.model = res.clase;
          if (res.clase > 0) {
            this.backDisable = false;
          }

          //console.log(this.item.materia_codigo_clase.length -1,res.clase)

          let totalV = this.item.materia_codigo_clase.length - 1;

          if (res.clase > totalV) {
            this.claseActual = totalV;
          }

          let cantidadClases = this.item.materia_codigo_clase[this.claseActual]
            .materia_codigo_link;

          cantidadClases = cantidadClases.length;

          if (res.clase == cantidadClases) {
            this.nextDisable = true;
          }

          console.log("esta es la clase actual", this.claseActual)
          console.log("esta es el reproductor actual", this.reproductorActual)
          console.log('este es link', this.item.materia_codigo_clase[this.claseActual]
            .materia_codigo_link[this.reproductorActual].link)
          //console.log(this.reproductorActual)
          //   this.reproductorActualBackgroundList = this.reproductorActual
          this.initializeVideo();
          this.intervalProcentaje();
          // this.player.loadVideoById({
          //   videoId: this.item.materia_codigo_clase[this.claseActual]
          //     .materia_codigo_link[this.reproductorActual].link,
          //   startSeconds:
          //     this.item.materia_codigo_clase[this.claseActual]
          //       .materia_codigo_link[this.reproductorActual]
          //       .videoActualSegundo || 0
          // });

          this.intervalProcentaje();
        });
    }
  },

  computed: {
    player() {
      return this.$refs.youtube.player;
    },
    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    reproductorActual: function (e) {
      this.reproductorActualBackgroundList = parseInt(e);
    }
  }
};
</script>
